(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-contact"] && !Shopify.designMode) return;
  try {
    
function egContactInit(root){
  if(root.dataset.ready)return;
  root.dataset.ready='1';
  const inputs=[...root.querySelectorAll('[data-eg-count]')];
  const error=root.querySelector('[data-eg-error]');
  const form=root.closest('form');
  const validate=()=>{
    const total=inputs.reduce((n,input)=>n+Number(input.value||0),0);
    const valid=Number.isFinite(total)&&total>=Number(root.dataset.min);
    inputs[0].setCustomValidity(valid?'':root.dataset.error);
    return valid;
  };
  inputs.forEach(input=>input.addEventListener('input',()=>{validate();error.textContent='';}));
  inputs[0].addEventListener('invalid',()=>{if(inputs[0].validity.customError)error.textContent=root.dataset.error;});
  form.addEventListener('submit',e=>{
    if(!validate()){
      e.preventDefault();e.stopImmediatePropagation();
      error.textContent=root.dataset.error;
      inputs[0].reportValidity();
    }
  },true);
  validate();
}
document.querySelectorAll('[data-eg-contact]').forEach(egContactInit);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-eg-contact]').forEach(egContactInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-product"] && !Shopify.designMode) return;
  try {
    
function egProductInit(root){
  if(root.dataset.ready)return;root.dataset.ready='1';
  const input=root.querySelector('[data-eg-name]');
  const variant=root.querySelector('[data-eg-variant]');
  if(variant)variant.addEventListener('change',()=>{if(input)(()=>{try{sessionStorage.setItem('eg-name-'+input.form.id,input.value);}catch{}})();const url=new URL(window.location.href);url.searchParams.set('variant',variant.value);window.location.assign(url.toString());});
  if(input){try{const saved=sessionStorage.getItem('eg-name-'+input.form.id);if(saved){input.value=saved;sessionStorage.removeItem('eg-name-'+input.form.id);}}catch{}}

  const form=root.querySelector('form'),sticky=root.querySelector('[data-eg-sticky-cta]'),bar=root.querySelector('.eg-sticky');
  let submitting=false;
  const updateSticky=()=>{if(sticky)sticky.textContent=input&&!input.value.trim()?sticky.dataset.personalize:sticky.dataset.ready;};
  const reveal=field=>{field.focus({preventScroll:true});field.scrollIntoView({behavior:'auto',block:'center'});};
  if(sticky&&form){
    sticky.addEventListener('click',e=>{
      e.preventDefault();
      if(input)input.value=input.value.normalize('NFC').trim();
      if(!form.checkValidity()){const invalid=form.querySelector(':invalid');if(invalid)reveal(invalid);form.reportValidity();updateSticky();return;}
      const add=form.querySelector('[name="add"]');
      if(!add||add.disabled||submitting)return;
      submitting=true;sticky.setAttribute('aria-busy','true');
      form.requestSubmit(add);
      setTimeout(()=>{submitting=false;sticky.removeAttribute('aria-busy');},3000);
    });
    if('IntersectionObserver' in window&&bar){const observer=new IntersectionObserver(entries=>{bar.classList.toggle('eg-form-visible',entries[0].isIntersecting);});observer.observe(form);}
  }
  updateSticky();
  if(!input)return;
  input.addEventListener('input',updateSticky);
  const update=()=>document.querySelectorAll('[data-eg-name-preview]').forEach(preview=>preview.textContent=input.value.trim()||preview.dataset.default);
  input.addEventListener('input',()=>{input.setCustomValidity('');update();});
  input.form.addEventListener('submit',e=>{input.value=input.value.normalize('NFC').trim();if(!input.value){e.preventDefault();e.stopImmediatePropagation();input.focus();input.reportValidity();}},true);
  update();
}
document.querySelectorAll('[data-eg-product]').forEach(egProductInit);
document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('[data-eg-product]').forEach(egProductInit);const input=document.querySelector('[data-eg-name]');if(input)document.querySelectorAll('[data-eg-name-preview]').forEach(p=>p.textContent=input.value.trim()||p.dataset.default);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eg-scents"] && !Shopify.designMode) return;
  try {
    
function egGuideInit(root){if(root.dataset.ready)return;root.dataset.ready='1';const buttons=root.querySelectorAll('[data-filter]');const choose=(group)=>{buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===group)));root.querySelectorAll('[data-set]').forEach(card=>card.hidden=group!=='all'&&card.dataset.set!==group);};buttons.forEach(b=>b.addEventListener('click',()=>choose(b.dataset.filter)));const group=new URLSearchParams(location.search).get('set');if(buttons.length&&['him','her'].includes(group))choose(group);root.addEventListener('shopify:block:select',e=>{choose('all');});}document.querySelectorAll('[data-eg-guide]').forEach(egGuideInit);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-eg-guide]').forEach(egGuideInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essentia-gdy-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('essentia-gdy-product')) {
  customElements.define('essentia-gdy-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.form = this.querySelector('.es-set-product-form');
      this.select = this.querySelector('[data-variant-select]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.hero = this.querySelector('[data-hero]');
      this.sticky = this.querySelector('[data-sticky]');
      this.addButton = this.querySelector('[data-main-add]');
      if (this.select && this.variantInput) {
        this.select.removeAttribute('name');
        this.variantInput.disabled = false;
        this.select.addEventListener('change', () => this.updateVariant(true), {signal});
        this.updateVariant(false);
      }
      this.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.addEventListener('click', event => {
          if (!this.hero) return;
          event.preventDefault();
          this.setImage(thumb.dataset.src, thumb.dataset.alt, thumb.dataset.width, thumb.dataset.height);
        }, {signal});
      });
      this.addEventListener('shopify:block:select', event => {
        const details = event.target.querySelector('details');
        if (details) details.open = true;
      }, {signal});
      if (this.sticky && this.addButton && 'IntersectionObserver' in window) {
        this.sticky.hidden = false;
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.sticky.classList.toggle('is-visible', visible);
          this.sticky.inert = !visible;
          this.sticky.setAttribute('aria-hidden', String(!visible));
        });
        this.observer.observe(this.addButton);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
    setImage(src, alt, width, height) {
      if (!this.hero || !src) return;
      this.hero.src = src;
      this.querySelectorAll('[data-image-link]').forEach(link => link.href = src);
      this.hero.alt = alt || '';
      this.hero.width = Number(width) || 1200;
      this.hero.height = Number(height) || 1200;
      this.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        const active = thumb.dataset.src === src;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
    updateVariant(updateUrl) {
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      if (!variant) return;
      this.variantInput.value = variant.id;
      this.querySelectorAll('[data-price]').forEach(node => node.textContent = variant.price);
      this.querySelectorAll('[data-compare]').forEach(node => node.textContent = variant.compare);
      this.querySelectorAll('[data-savings]').forEach(node => node.textContent = variant.savings);
      this.querySelectorAll('[data-sale-only]').forEach(node => node.hidden = !variant.sale);
      this.querySelectorAll('[data-main-add], [data-sticky-add]').forEach(button => button.disabled = !variant.available);
      this.querySelectorAll('[data-add-text]').forEach(node => node.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel);
      this.querySelectorAll('[data-availability]').forEach(node => node.textContent = variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel);
      const quantity = this.querySelector('[data-quantity]');
      if (quantity) {
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max;
        else quantity.removeAttribute('max');
        let nextQuantity = Math.max(Number(quantity.value) || variant.min, variant.min);
        nextQuantity = variant.min + Math.ceil((nextQuantity - variant.min) / variant.step) * variant.step;
        if (variant.max) nextQuantity = Math.min(nextQuantity, variant.max);
        quantity.value = nextQuantity;
      }
      if (updateUrl && this.dataset.variantGallery === 'true' && variant.image) this.setImage(variant.image, variant.alt, variant.width, variant.height);
      if (updateUrl && !window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      if (updateUrl) this.variantInput.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["essentia-set-customizable"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('essentia-curated-product')) {
  customElements.define('essentia-curated-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
      this.form = this.querySelector('.es-set-product-form');
      this.select = this.querySelector('[data-variant-select]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.hero = this.querySelector('[data-hero]');
      this.sticky = this.querySelector('[data-sticky]');
      this.addButton = this.querySelector('[data-main-add]');
      if (this.select && this.variantInput) {
        this.select.removeAttribute('name');
        this.variantInput.disabled = false;
        this.select.addEventListener('change', () => this.updateVariant(true), {signal});
        this.updateVariant(false);
      }
      this.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.addEventListener('click', event => {
          if (!this.hero) return;
          event.preventDefault();
          this.setImage(thumb.dataset.src, thumb.dataset.alt, thumb.dataset.width, thumb.dataset.height);
        }, {signal});
      });
      this.addEventListener('shopify:block:select', event => {
        const details = event.target.querySelector('details');
        if (details) details.open = true;
      }, {signal});
      if (this.sticky && this.addButton && 'IntersectionObserver' in window) {
        this.sticky.hidden = false;
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.sticky.classList.toggle('is-visible', visible);
          this.sticky.inert = !visible;
          this.sticky.setAttribute('aria-hidden', String(!visible));
        });
        this.observer.observe(this.addButton);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
    setImage(src, alt, width, height) {
      if (!this.hero || !src) return;
      this.hero.src = src;
      this.hero.alt = alt || '';
      this.hero.width = Number(width) || 1200;
      this.hero.height = Number(height) || 1200;
      this.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        const active = thumb.dataset.src === src;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
    updateVariant(updateUrl) {
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      if (!variant) return;
      this.variantInput.value = variant.id;
      this.querySelectorAll('[data-price]').forEach(node => node.textContent = variant.price);
      this.querySelectorAll('[data-compare]').forEach(node => node.textContent = variant.compare);
      this.querySelectorAll('[data-savings]').forEach(node => node.textContent = variant.savings);
      this.querySelectorAll('[data-sale-only]').forEach(node => node.hidden = !variant.sale);
      this.querySelectorAll('[data-main-add], [data-sticky-add]').forEach(button => button.disabled = !variant.available);
      this.querySelectorAll('[data-add-text]').forEach(node => node.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldLabel);
      this.querySelectorAll('[data-availability]').forEach(node => node.textContent = variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel);
      const quantity = this.querySelector('[data-quantity]');
      if (quantity) {
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max;
        else quantity.removeAttribute('max');
        let nextQuantity = Math.max(Number(quantity.value) || variant.min, variant.min);
        nextQuantity = variant.min + Math.ceil((nextQuantity - variant.min) / variant.step) * variant.step;
        if (variant.max) nextQuantity = Math.min(nextQuantity, variant.max);
        quantity.value = nextQuantity;
      }
      if (updateUrl && this.dataset.variantGallery === 'true' && variant.image) this.setImage(variant.image, variant.alt, variant.width, variant.height);
      if (updateUrl && !window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      if (updateUrl) this.variantInput.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
